import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { XCircle } from "lucide-react";

const PaymentCancel = () => {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="absolute inset-0 hero-glow opacity-50" />
      
      <Card className="w-full max-w-md bg-card/50 backdrop-blur-md border-black/10 relative z-10">
        <CardContent className="py-12 text-center">
          <div className="w-20 h-20 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-10 w-10 text-red-500" />
          </div>
          <h1 className="text-2xl font-bold mb-2">Payment Cancelled</h1>
          <p className="text-muted-foreground mb-6">
            Your payment has been cancelled. No charges have been made to your account.
          </p>
          <div className="flex flex-col gap-3">
            <Link to="/dashboard">
              <Button className="w-full bg-primary text-primary-foreground hover:bg-primary/90 rounded-full" data-testid="return-dashboard">
                Return to Dashboard
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="w-full rounded-full">
                Back to Home
              </Button>
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentCancel;
